<template>
  <section :class="$style.wrapper">
    <header :class="$style.header">
      <h2 :class="$style.title">メモ</h2>
      <ButtonClose @click="$emit('close')" />
    </header>
    <section :class="$style.body">
      <FlatButton
        v-if="!isAddition"
        :class="$style.addButton"
        size="small"
        variant="primary"
        @click="toggleIsAddition"
      >
        ＋追加
      </FlatButton>
      <ul :class="$style.list">
        <li v-if="isAddition" :class="$style.item">
          <MemoEditor
            title="追加"
            :content="newMemo"
            :disabled="isUpdating"
            is-editing
            @save="createMemo"
            @delete="toggleIsAddition"
          />
        </li>
        <li :class="$style.item" v-for="memo in memos" :key="memo.id">
          <MemoEditor
            :title="format(new Date(memo.createdAt), 'yyyy/M/d H:mm')"
            :content="memo.content"
            :disabled="isUpdating"
            @delete="() => deleteMemo(memo.id)"
          />
        </li>
      </ul>
      <p v-if="memos.length === 0 && !isAddition">メモはありません</p>
    </section>
  </section>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import ButtonClose from '@/components/atoms/ButtonClose.vue'
import { type MemoModalMemoFragment } from './MemoModal.generated'
import { format } from 'date-fns'
import FlatButton from '@/components/atoms/FlatButton.vue'
import MemoEditor from './MemoEditor.vue'

defineProps<{
  memos: MemoModalMemoFragment[]
  isUpdating: boolean
}>()

const emits = defineEmits<{
  (event: 'close'): void
  (event: 'create', content: string): void
  (event: 'delete', id: MemoModalMemoFragment['id']): void
}>()

const isAddition = ref(false)

const toggleIsAddition = () => {
  isAddition.value = !isAddition.value
}

const newMemo = ref('')

watch(isAddition, () => {
  newMemo.value = ''
})

const createMemo = (content: string) => {
  isAddition.value = false
  emits('create', content)
}

const deleteMemo = (id: MemoModalMemoFragment['id']) => {
  emits('delete', id)
}
</script>

<style lang="scss" module>
.wrapper {
  width: 90vw;
  max-width: 620px;
}

.header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 16px;
  border-bottom: 1px solid $color-border-low-emphasis;
}

.title {
  font-size: 16px;
  font-weight: bold;
}

.body {
  padding: 10px 40px 40px;

  &__buttonWrapper {
    margin-top: 44px;
  }
}

.addButton {
  display: block;
  margin-top: 10px;
}

.list {
  margin-top: 20px;
}

.item {
  &:nth-child(n + 2) {
    margin-top: 20px;
  }
}
</style>
